import Vue from 'vue'

const state = {
  products: []
}

const mutations = {
  'SET_PRODUCTS_LIST' (state, products) {
    state.products = products
    localStorage.setItem('products', JSON.stringify(products))
  },
  'TOGGLE_ALL_PRODUCTS_VALIDATION' (state, status) {
    state.products.forEach(product => {
      product.enabled = status
    })
    localStorage.setItem('products', JSON.stringify(state.products))
  },
  'TOGGLE_PRODUCT_VALIDATION' (state, product) {
    const record = state.products.find(element => `${element.id}-${element.type}` === `${product.id}-${product.type}`)
    if (record) {
      record.enabled = product.enabled
    }
    localStorage.setItem('products', JSON.stringify(state.products))
  }
}

const actions = {
  setProductsList: ({commit}, eventId) => {
    Vue.http.post('products', { event: eventId })
      .then(response => {
        response.json().then(products => {
          products.forEach(product => {
            product.enabled = product.enabled === '1'
          })
          commit('SET_PRODUCTS_LIST', products)
        })
      })
  },
  toggleAllProductsValidation: ({commit}, status) => {
    commit('TOGGLE_ALL_PRODUCTS_VALIDATION', status)
  },
  toggleProductValidation: ({commit}, product) => {
    commit('TOGGLE_PRODUCT_VALIDATION', product)
  },
  eraseLocalProductsData: ({commit}) => {
    commit('SET_PRODUCTS_LIST', [])
    localStorage.removeItem('products')
  },
  loadProductsFromLocalStore: ({commit}) => {
    const products = localStorage.getItem('products')
    if (!products) {
      return
    }
    commit('SET_PRODUCTS_LIST', JSON.parse(products))
  }
}

const getters = {
  products (state) {
    return state.products
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js